import { render, staticRenderFns } from "./cropImage.vue?vue&type=template&id=3ae5f30d&"
import script from "./cropImage.vue?vue&type=script&lang=js&"
export * from "./cropImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/upload/cropImage.vue"
export default component.exports